import { render, staticRenderFns } from "./DeliveryDateDetailsPage.vue?vue&type=template&id=61309be0"
import script from "./DeliveryDateDetailsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryDateDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports